<template >
  <div style="display:contents;">
    <div 
      v-if="!activeFilters.includes(scope.column.property)" 
      class="header-item">
      <span>{{ scope.column.label }}</span>
      <span 
        class="el-icon-search header-icon" 
        @click="activeFilters.push(scope.column.property)" />
    </div>
    <el-input
      v-if="type === 'input' && activeFilters.includes(scope.column.property)"
      v-model="value[scope.column.property]"
      :clearable="true"
      class="filter-input"
      placeholder="Search"
      autofocus
      @clear="clear()"
    >
      <span
        slot="suffix"
        class="el-icon-search header-icon"
        @click="activeFilters.push(scope.column.property)"
      />
    </el-input>
    <el-select
      v-if="type === 'select' && activeFilters.includes(scope.column.property)"
      :clearable="true"
      v-model="value[scope.column.property]"
    >
      <el-option 
        v-for="(item, index) in meta.options" 
        :key="index" 
        :label="item" 
        :value="item"/>
    </el-select>
    <el-date-picker
      v-if="type === 'dateRange' && activeFilters.includes(scope.column.property)"
      v-model="value[scope.column.property]"
      type="daterange"
      range-separator="To"
      start-placeholder="Start"
      end-placeholder="End"
      value-format="yyyy-MM-dd"
    />
  </div>
</template>
<script>
import { Select, Option, DatePicker } from "element-ui";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name] : DatePicker
  },
  props: {
    visibleFilters: {
      type: Array,
      default: [],
    },
    scope: {
      type: Object,
    },
    value: {
      type: Object,
    },
    type: {
      type: String,
      default: "input",
    },
    meta: {
      type: Object,
      default() {
        return {
          options: [],
          // dateRange: [],
        };
      },
    },
  },
  data() {
    return {
      activeFilters: [],
    };
  },
  watch: {
    visibleFilters(val) {
      this.activeFilters = [...val];
    },
    value: {
      deep: true,
      handler: function (val, oldValue) {
        const emptyFilters = Object.filter(val, (i) => i.length === 0);
        this.activeFilters = this.activeFilters.filter((i) => {
          return Object.keys(emptyFilters).indexOf(i) < 0;
        });
      },
    },
  },
  methods: {
    clear() {
      this.activeFilters = this.activeFilters.filter(
        (f) => f !== this.scope.column.property
      );
    },
  },
};
</script>
<style scoped>
/deep/ .filter-input input {
  background: transparent !important;
  color: #2dce89;
  border-radius: 0px;
  border: 0px;
  border-bottom: 1px solid #2dce89;
}

.header-icon {
  display: none;
  cursor: pointer;
}

.header-item:hover .header-icon {
  display: block;
}

.header-item {
  width: 100%;
  display: grid;
  grid-template-columns: 4fr 1fr;
  align-items: center;
}
</style>